(function() {
  'use strict';

  function getViewportType() {
    return window.matchMedia('(max-width: 1023px)').matches ? 'mobile' : 'desktop';
  }

  function normalizeText(value, maxLength) {
    var text = String(value || '').replace(/\s+/g, ' ').trim();
    if (!text) return '';
    if (!maxLength || text.length <= maxLength) return text;
    return text.substring(0, maxLength);
  }

  function assignDefined(target, source) {
    Object.keys(source || {}).forEach(function(key) {
      var value = source[key];
      if (value === undefined || value === null || value === '') {
        return;
      }

      target[key] = value;
    });

    return target;
  }

  var MemoketBweAnalytics = {
    buildPayload: function(properties) {
      var payload = {
        page_type: 'beta_program',
        page_template: 'beta-program',
        viewport_type: getViewportType()
      };

      return assignDefined(payload, properties || {});
    },

    track: function(eventName, properties) {
      if (!window.MemoketAnalytics || typeof window.MemoketAnalytics.track !== 'function') {
        return null;
      }

      return window.MemoketAnalytics.track(eventName, this.buildPayload(properties));
    },

    trackCtaClick: function(properties) {
      return this.track('cta_click', properties);
    },

    trackLegacyEvent: function(eventName, properties) {
      return this.track(eventName, properties);
    },

    trackVideoPlayClick: function(properties) {
      return this.track('video_play_click', properties);
    },

    trackFaqInteraction: function(properties) {
      return this.track('faq_interaction', properties);
    },

    normalizeText: normalizeText
  };

  window.MemoketBweAnalytics = MemoketBweAnalytics;
})();
